import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SignedIn, SignedOut, SignInButton } from "@clerk/clerk-react";
import { getExperimentVariant, trackExperimentEvent } from '../utils/abTesting';
import { trackEvent } from '../utils/analytics';

export default function Hero() {
  const { t } = useTranslation();
  const heroVariant = getExperimentVariant('HERO_COPY', ['A', 'B']);

  useEffect(() => {
    trackEvent('landing_view', { variant: heroVariant });
    trackExperimentEvent('HERO_COPY', heroVariant, 'view', {
      source: 'HeroComponent'
    });
  }, [heroVariant]);

  const handleCtaClick = () => {
    trackExperimentEvent('HERO_COPY', heroVariant, 'cta_click', {
      location: 'hero_main_cta'
    });
  };

  return (
    <section className="hero">
      <div className="hero-glow"></div>
      <div className="hero-glow-pink"></div>

      <div className="hero-badge">{t('landing.hero.badge', { defaultValue: 'AI-Powered · No Card Required · Results in Seconds' })}</div>

      <h1 className="hero-h1">
        {heroVariant === 'B' 
          ? t('landing.hero.line1_alt', { defaultValue: 'Stop Sounding Generic' }) 
          : t('landing.hero.line1', { defaultValue: 'Write Instagram Copy' })}
        <br/>
        {heroVariant === 'B'
          ? <em>{t('landing.hero.line2_alt', { defaultValue: 'AI for Modern Creators' })}</em>
          : <>{t('landing.hero.line1b', { defaultValue: 'That ' })}<em>{t('landing.hero.line2', { defaultValue: 'Actually Converts' })}</em></>
        }
      </h1>

      <p className="hero-sub">
        {t('landing.hero.sub', { defaultValue: 'Bios that position you. Captions that hook. Hashtags that reach the right people. Premium AI copy for creators and brands who refuse to sound generic.' })}
      </p>

      <div className="hero-ctas">
        <SignedOut>
          <SignInButton mode="modal">
            <button className="btn-primary" type="button" onClick={handleCtaClick}>
              {heroVariant === 'B'
                ? t('landing.cta.start_alt', { defaultValue: 'Start Creating Now — It\'s Free' })
                : t('landing.cta.start', { defaultValue: 'Try Free — No Card Required' })}
            </button>
          </SignInButton>
        </SignedOut>

        <SignedIn>
          <Link to="/dashboard" className="btn-primary">
            {t('landing.cta.dashboard', { defaultValue: 'Go to Dashboard' })}
          </Link>
        </SignedIn>

        <a href="#before-after" className="btn-ghost">
          {t('landing.cta.examples', { defaultValue: 'See Real Examples ↓' })}
        </a>
      </div>

      <div className="hero-visual">
        <div className="phone-wrap main">
          <div className="phone-top"><div className="phone-notch"></div></div>
          <div className="phone-screen">
            <div className="ig-header">
              <div className="ig-avatar"></div>
              <div style={{ textAlign: 'left' }}>
                <div className="ig-name">@sophiastyle</div>
                <div className="ig-handle">{t('landing.hero.mock.niche', { defaultValue: 'Fashion & Lifestyle' })}</div>
              </div>
            </div>
            <div className="ig-bio">
              {t('landing.hero.mock.bioName', { defaultValue: '✦ Fashion editor turned creator' })}<br/>
              {t('landing.hero.mock.bioSub', { defaultValue: 'Curating effortless style since \'21' })}<br/>
              {t('landing.hero.mock.bioLoc', { defaultValue: '🇮🇹 Milan | DM for collabs' })}<br/>
              <span className="cursor-blink"></span>
            </div>
            <div className="ig-stats">
              <div className="ig-stat"><div className="ig-stat-n">{t('landing.hero.mock.s1', { defaultValue: 'Preview' })}</div><div className="ig-stat-l">{t('landing.hero.mock.s1Sub', { defaultValue: 'followers' })}</div></div>
              <div className="ig-stat"><div className="ig-stat-n">{t('landing.hero.mock.s2', { defaultValue: 'Modern' })}</div><div className="ig-stat-l">{t('landing.hero.mock.s2Sub', { defaultValue: 'style' })}</div></div>
              <div className="ig-stat"><div className="ig-stat-n">{t('landing.hero.mock.s3', { defaultValue: 'Daily' })}</div><div className="ig-stat-l">{t('landing.hero.mock.s3Sub', { defaultValue: 'updates' })}</div></div>
            </div>
            <div className="post-preview">
              <div className="post-img">🌿</div>
              <div className="post-caption">{t('landing.hero.mock.caption', { defaultValue: 'Soft mornings, slower Sundays. This look is everything I needed this season — minimal but intentional. ✦ #StyleEdit #SlowFashion' })}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
